import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8568c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, "产品分类", -1))

import { ref, onMounted, watch, nextTick } from "vue";
import type { FilterNodeMethodFunction, TreeInstance } from "element-plus";
import { getMenuData } from "@/api/product";
import { useProIndexStore } from "@/store/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewSideMenu',
  props: {
  index: {
    type: String,
    // required: true
  },
},
  emits: ["openSubMenu"],
  setup(__props, { emit: emits }) {

const props = __props;

const menuList = ref([]);
const treeRef = ref<TreeInstance>();
const currentNode = ref();


const filterNode: FilterNodeMethodFunction = (value: string, data: Tree) => {
  if (!value) return true;
  return data.label.includes(value);
};

const expandedKeys = ref<number[]>([]);
watch(
  () => useProIndexStore().proIndex,
  (val) => {
    // console.log("6666,监听useProIndexStore().proIndex", val);
    expandedKeys.value = [Number(val)];
    currentNode.value = Number(val);

    // console.log(expandedKeys.value);
  },
  {
    immediate: true,
    deep: true,
  }
);
onMounted(async () => {
  const res = await getMenuData();
  menuList.value = res.data;
});



// 选择节点
const expandCurrentNode = async (key: string) => {
  emits("openSubMenu", key.id, String(key.index));
};
const clickCurrentNode = async (key: string) => {
  // emits("expandCurrentNode", key);
  // console.log("kkkkkkkkk", key);
  if (!key.is_children) {
    // window.open(`http://localhost:8080/prodetail?index=${key.index}`);
    window.open(`https://rekeymed.com/prodetail?index=${key.index}`);
  }
};

// const openSubMenu = (index: string, indexPath: string[]) => {
//   emits("openSubMenu", index);
// };

// 选择节点
// const clickCurrentNode = (key) =>{
//   console.log(key);

// }

return (_ctx: any,_cache: any) => {
  const _component_SemiSelect = _resolveComponent("SemiSelect")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Folder = _resolveComponent("Folder")!
  const _component_FolderOpened = _resolveComponent("FolderOpened")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "tac" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_tree, {
        ref_key: "treeRef",
        ref: treeRef,
        "node-key": "id",
        style: {"max-width":"600px"},
        class: "filter-tree",
        data: menuList.value,
        props: { children: 'children', label: 'label' },
        "filter-node-method": filterNode,
        "default-expanded-keys": expandedKeys.value,
        "current-node-key": currentNode.value,
        "highlight-current": "",
        "check-on-click-node": "",
        onNodeExpand: expandCurrentNode,
        onNodeClick: clickCurrentNode
      }, {
        default: _withCtx(({ node }) => [
          (node.isLeaf)
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "el-icon--left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SemiSelect)
                ]),
                _: 1
              }))
            : (!node.expanded)
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 1,
                  class: _normalizeClass(["el-icon--left", { 'is-main': node.level==1 }])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Folder)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              : (_openBlock(), _createBlock(_component_el_icon, {
                  key: 2,
                  class: _normalizeClass(["el-icon--left", { 'is-main': node.level==1 }])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FolderOpened)
                  ]),
                  _: 2
                }, 1032, ["class"])),
          _createElementVNode("span", {
            class: _normalizeClass(["prefix", { 'is-main': node.level==1 }])
          }, _toDisplayString(node.label), 3)
        ]),
        _: 1
      }, 8, ["data", "default-expanded-keys", "current-node-key"])
    ]),
    _: 1
  }))
}
}

})